module.exports = __webpack_public_path__ + "static/website-collect-points-0ced7bc8c8f5a68eaf6a73d36861d626.png";